import React, { useState } from 'react';

import { Col, Dropdown, Modal } from 'react-bootstrap';
import '../JobStageSummary.scss';
import Textfield from '../../../_common/Textfield/Textfield';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import { useQuery } from '@apollo/client/react';
import { GET_WELL_HEADS_BY_STAGE_GROUP_ID } from '../../../../graphql/client/queries';
import { GetWellheadsByStageGroupId, GetWellheadsByStageGroupId_getWellheadsByStageGroupId as StageWellheads } from '../../../../types/schemaTypes';
import { Loading } from '../../../_common/Loading/Loading';

interface EndStageSummaryModalProps {
    showEndStageModal: boolean;
    stageGroupId: number | undefined;
    handleOnClose: (modalType) => void;
    handleOnSave: (jobStageIds: number[], comments: string) => void;
    mutationLoading: boolean;
    mutationError: string | undefined;
}

const EndStageSummaryModal = ({
    showEndStageModal,
    handleOnClose,
    stageGroupId,
    handleOnSave,
    mutationLoading,
    mutationError,
}: EndStageSummaryModalProps): React.ReactElement => {
    const [wellheadStage, setWellheadStage] = useState<string>();
    const [comments, setComments] = useState<string>('');
    const [jobStageIds, setJobStageIds] = useState<number[]>();

    const { loading, error, data } = useQuery<GetWellheadsByStageGroupId>(GET_WELL_HEADS_BY_STAGE_GROUP_ID, {
        variables: {
            stageGroupId: stageGroupId,
        },
        fetchPolicy: 'network-only',
    });
    const wellheadStageList: StageWellheads[] = [];
    if (data?.getWellheadsByStageGroupId) {
        data.getWellheadsByStageGroupId.forEach(wellHead => {
            if (wellHead && wellHead.status !== 'Completed') wellheadStageList.push(wellHead);
        });
    }

    const onClickClose = () => {
        handleOnClose('endStage');
    };

    const onClickSave = () => {
        if (jobStageIds) handleOnSave(jobStageIds, comments);
    };

    const handleOnChangeWellheadStage = (wellhead: string, stageNumber: number, jobStageId: number) => {
        if (wellhead === 'ALL') {
            const tempJobStageIds: number[] = [];
            wellheadStageList.map(WellheadStageItem => {
                tempJobStageIds.push(WellheadStageItem.jobStageId);
            });
            setWellheadStage('Select All');
            setJobStageIds(tempJobStageIds);
        } else {
            setWellheadStage(`${wellhead} - Stage ${stageNumber}`);
            setJobStageIds([jobStageId]);
        }
    };

    const handleOnChangeComments = (value: string) => {
        setComments(value);
    };

    if (wellheadStageList.length === 1 && !wellheadStage) {
        handleOnChangeWellheadStage(
            wellheadStageList[0].wellhead,
            wellheadStageList[0].stage,
            wellheadStageList[0].jobStageId,
        );
    }
    if (wellheadStageList.length > 1 && !wellheadStage) {
        handleOnChangeWellheadStage('ALL', 0, 0);
    }

    return (
        <Modal show={showEndStageModal} onHide={onClickClose} dialogClassName="StageModal-Container">
            {mutationLoading && (
                <span className="AddStageModal-Loading">
                    <Loading />
                </span>
            )}

            <Modal.Header className="AddStageModal-Header">
                <Modal.Title className="AddStageModal-Header-Container">
                    <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AddStageModal-Title">End Stage</div>
                    <div className="AddStageModal-Error">{mutationError}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="AddStageModal-Body">
                <Col>
                    <div>
                        Select a Wellhead-Stage below and provide comments (if any) and click continue to proceed.
                    </div>
                </Col>
                <Col>
                    <div>
                        <b>
                            ALL FULL BOXES WILL BE MOVED TO UNASSIGNED INVENTORY AND PARTIAL BOXES WILL BE MOVED TO THE
                            DANCE FLOOR
                        </b>
                    </div>
                </Col>

                <Col md={8}>
                    <Dropdown>
                        <Dropdown.Toggle variant="outline-dark" id="dropdown-basic" className="EndStage-wellheadStage">
                            <span>{wellheadStage}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {!loading && wellheadStageList.length > 1 && (
                                <Dropdown.Item 
                                //onSelect={() => handleOnChangeWellheadStage('ALL', 0, 0)}
                                onClick={() => handleOnChangeWellheadStage('ALL', 0, 0)}
                                >
                                    Select All
                                </Dropdown.Item>
                            )}
                            {loading ? (
                                <div className="WellheadStage-Loading">
                                    <Loading />
                                </div>
                            ) : (
                                wellheadStageList.map((wellheadStageItem, index) => (
                                    <Dropdown.Item
                                        key={index}
                                        // onSelect={() =>
                                        //     handleOnChangeWellheadStage(
                                        //         wellheadStageItem.wellhead,
                                        //         wellheadStageItem.stage,
                                        //         wellheadStageItem.jobStageId,
                                        //     )
                                        // }
                                        onClick={() =>
                                            handleOnChangeWellheadStage(
                                                wellheadStageItem.wellhead,
                                                wellheadStageItem.stage,
                                                wellheadStageItem.jobStageId,
                                            )
                                        }
                                    >
                                        {wellheadStageItem.wellhead} - Stage {wellheadStageItem.stage}
                                    </Dropdown.Item>
                                ))
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>

                <Col md={8}>
                    <Textfield
                        label="Comments (optional)"
                        name="endStageComments"
                        onChange={element => handleOnChangeComments(element.target.value)}
                        maxLength={1000}
                    />
                </Col>
            </Modal.Body>

            <Modal.Footer className="AddStageModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton
                    title="Continue"
                    onClick={() => onClickSave()}
                    isDisabled={jobStageIds && !mutationLoading ? false : true}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default EndStageSummaryModal;
